import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from './api';

export const membersKey = ['members'] as const;
export const memberKey = (id: string) => ['members', id] as const;
export const invitationsKey = ['invitations'] as const;

export function useMembers() {
  return useInfiniteQuery({
    queryKey: membersKey,
    queryFn: ({ pageParam }) => api.members.list({ cursor: pageParam, limit: 50 }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

export function useMember(id: string) {
  return useQuery({ queryKey: memberKey(id), queryFn: () => api.members.get(id) });
}

/** One Idempotency-Key per form submission attempt: kept across retries, renewed after success. */
export function useIdempotencyKey(): [string, () => void] {
  const [key, setKey] = useState(() => crypto.randomUUID());
  return [key, () => setKey(crypto.randomUUID())];
}
